import moment from 'moment';
import { sha256 } from 'js-sha256';

import { asciiToHex } from 'utils/stringUtils';
import { appConfig } from 'config/customization';
import { UTILITIES } from 'constants/utilitiesMappers';

const firstDataBaseURL = `${process.env.REACT_APP_API_BASE_URL}api/v1/payments/first_data`;
const currencyCode = '032';
const CARD_TYPE = 'tipo_tarjeta';
const CREDIT = 'credit';

const getCardTypeNumber = value => (value === CREDIT ? 1 : 2);

const EdesPaymentDetails = details =>
  details.map(detail => ({ Cod_Barr: detail.barcode, Imp: detail.balance || detail.amount }));

const EdenPaymentDetails = details =>
  details.map(detail => ({ Ref_Pago: detail.external_id, Imp: detail.balance || detail.amount }));

const PaymentDetailsMappers = {
  [UTILITIES.eden]: EdenPaymentDetails,
  [UTILITIES.edes]: EdesPaymentDetails
};

export const generateFDFormData = (totalAmount, formValues, oid, paymentDetails, agentTransactionId) => {
  const txndatetime = moment().format('YYYY:MM:DD-HH:mm:ss');
  const hashInput = `${process.env.REACT_APP_FIRST_DATA_STORENAME}${txndatetime}${totalAmount}${currencyCode}${process.env.REACT_APP_FIRST_DATA_SECRET}`;

  const hash = sha256(asciiToHex(hashInput));

  const details = PaymentDetailsMappers[appConfig.mappers](paymentDetails);

  const fieldArrays = [
    { name: 'storename', value: process.env.REACT_APP_FIRST_DATA_STORENAME },
    { name: 'txntype', value: 'sale' },
    { name: 'timezone', value: 'America/Buenos_Aires' },
    { name: 'txndatetime', value: txndatetime },
    { name: 'hash_algorithm', value: 'SHA256' },
    { name: 'mode', value: 'payonly' },
    { name: 'chargetotal', value: totalAmount },
    { name: 'currency', value: currencyCode },
    { name: 'oid', value: oid },
    { name: 'full_bypass', value: 'true' },
    { name: 'checkoutoption', value: 'combinedpage' },
    { name: 'responseFailURL', value: `${firstDataBaseURL}/failure_callback` },
    { name: 'responseSuccessURL', value: `${firstDataBaseURL}/success_callback` },
    {
      name: 'transactionNotificationURL',
      value: process.env.REACT_APP_FIRST_DATA_TRANSACTION_URL
    },
    { name: 'hash', value: hash },
    { name: 'cardFunction', value: formValues.cardFunction },
    { name: 'cardnumber', value: formValues.cardnumber },
    { name: 'holdername', value: formValues.holdername },
    { name: 'cvm', value: formValues.cvm },
    { name: 'expmonth', value: formValues.expmonth },
    { name: 'expyear', value: formValues.expyear },
    { name: 'utility_id', value: appConfig.utilityId }
  ];
  details.forEach((detail, index) =>
    fieldArrays.push({
      name: `customParam_itemsstring${index}`,
      value: JSON.stringify(detail)
    })
  );

  fieldArrays.push({
    name: `customParam_additionalInfo`,
    value: JSON.stringify({
      origen: 200,
      [CARD_TYPE]: getCardTypeNumber(formValues.cardFunction),
      ...(agentTransactionId ? { agentTransactionId } : {})
    })
  });

  return fieldArrays;
};
